<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Whitelist</p>
          <div class="float-right">
            <Filters />
            <el-tooltip content="Insert" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="insert()"
                class="ml10"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <Table />
        <Dialog />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/youtube/whitelist/Filters'
import Table from '../components/youtube/whitelist/Table'
import Dialog from '../components/youtube/whitelist/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Filters,
    Table,
    Dialog
  },

  computed: {
    ...mapState('youtubeWhitelist', ['loading'])
  },

  methods: {
    ...mapMutations('youtubeWhitelist', ['setDialogInsert']),
    insert() {
      this.setDialogInsert(true)
    }
  }
}
</script>
